import { TReferenceSelector } from '@modules/reference/types/selectors';

export const referenceSelector = (state: TReferenceSelector) => state.Reference;
